export const GET_AGREEMENTS = 'GET_AGREEMENTS';
export const SET_AGREEMENTS = 'SET_AGREEMENTS';
